import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 3,14 H 6.82843 L 12,19.1716 V 4.82842 L 6.82843,9.99999 H 3 Z M 12.2929,22.2929 6,16 H 2 C 1.44772,16 1,15.5523 1,15 V 8.99999 c 0,-0.55228 0.44772,-1 1,-1 H 6 L 12.2929,1.7071 C 12.9229,1.07713 14,1.5233 14,2.41421 V 21.5858 c 0,0.8909 -1.0771,1.337 -1.7071,0.7071 z M 21.5213,1.70711 c -0.3905,-0.39053 -1.0236,-0.39053 -1.4142,0 l -2.8284,2.82843 c -0.3905,0.39052 -0.3905,1.02368 0,1.41421 0.3905,0.39052 1.0237,0.39052 1.4142,0 l 2.8284,-2.82843 c 0.3906,-0.39052 0.3906,-1.02369 0,-1.41421 z M 24,11.8284 c 0,-0.5523 -0.4477,-1 -1,-1 h -4 c -0.5523,0 -1,0.4477 -1,1 0,0.5523 0.4477,1 1,1 h 4 c 0.5523,0 1,-0.4477 1,-1 z m -2.4787,8.2929 c 0.3905,0.3906 0.3905,1.0237 0,1.4142 -0.3905,0.3906 -1.0237,0.3906 -1.4142,0 l -2.8284,-2.8284 c -0.3906,-0.3905 -0.3906,-1.0237 0,-1.4142 0.3905,-0.3905 1.0237,-0.3905 1.4142,0 z"
  }));
});
var MultimediaVolume = AbstractIcon.withComponent(Icon);
MultimediaVolume.displayName = 'MultimediaVolume';
export default MultimediaVolume;